$ = jQuery.noConflict();

$(() => {

$('#topdf_button').click(function() {
  var options = {
  };
  var pdf = new jsPDF();
  pdf.addHTML($("#section-to-print"), 0, 0, options, function() {
    pdf.save('contrato-compra-venda.pdf');
  });
});



});
